import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Apropos.css';
import { useTranslation } from 'react-i18next';

const Apropos = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  return (
    <motion.div
      className={`wrapper_props ${isMobile ? 'mobile-view' : ''}`}
      variants={containerVariants}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      ref={ref}
    >
      <div className="container_16">
        <div className="row">
          <div className={`col-sm-6 ${isMobile ? 'order-2' : ''}`}>
            <h1>
              <u>{t('A Propos')}</u>
            </h1>
            <p>
              {t(
                'La société «PROFESSIONAL INSPECTORS» S.A exerce une activité de contrôle dans le domaine industriel, assure la vérification technique des équipements industriels conformément aux normes et réglementations en vigueur (ASME, AWS, API, AISI, ISO, NF, EN, etc.). Elle assure également les inspections périodiques de sécurité selon les normes nationales et internationales en vigueur. La réussite du «PROFESSIONAL INSPECTORS» repose sur son savoir-faire et sur les compétences de ses équipes. L`objectif de la société est de contribuer, avec un personnel qualifié et passionné par leur métier, des équipements de pointe et un système QHSE selon les exigences internationales, à assurer la sécurité des personnes et des installations tout au long de la chaîne de valeur et à améliorer la satisfaction de nos clients par le respect de leurs exigences.'
              )}
            </p>
            <div className="button_container">
              <motion.button
                className="button at_the_same_time"
                onClick={() => (window.location.href = '/about_us')}
                whileHover={{ scale: 1.1 }}
              >
                {t('Plus de détails')}
              </motion.button>
            </div>
          </div>
          <div className="pic">
            <motion.img
              src="images/apropos.jpg"
              alt="About Us"
              className="img-fluid intro_images"
              initial={{ opacity: 0, x: -50 }}
              animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
              transition={{ duration: 1 }}
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Apropos;
